import { render, staticRenderFns } from "./RCProject.vue?vue&type=template&id=dd473456"
import script from "./RCProject.vue?vue&type=script&lang=js"
export * from "./RCProject.vue?vue&type=script&lang=js"
import style0 from "./RCProject.vue?vue&type=style&index=0&id=dd473456&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports